































































import { Breadcrumb } from '@/components/BreadCrumbs.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import { Vue, Component, Watch } from 'vue-property-decorator';
import Container from '../../components/Container.vue';
import GroupEventsTab from './GroupEvents.tab.vue';
import GroupImagesTab from './GroupImages.tab.vue';
import GroupMembersTab from './GroupMembers.tab.vue';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import {
  GetGroupsResponsePayload,
  Group
} from '@/store/modules/admin/types/admin.types';
import {
  JbicChangeRequest,
  JbicChangeRequestDTO
} from '@/store/modules/admin/types/group.types';
import { checkJbicPermission } from '@/utils/rbac.util';
import { JbicPermissions } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

@Component({
  components: {
    Container,
    GroupEventsTab,
    GroupImagesTab,
    GroupMembersTab,
    ContentWrapper
  }
})
export default class GroupDetails extends Vue {
  @Action('admin/getSpecificGroups')
  getSpecificGroups!: (groupIds: number[]) => Promise<GetGroupsResponsePayload>;

  @State(({ admin }: RootState) => admin.apiState.getSpecificGroups)
  getSpecificGroupsApiState!: ApiState;

  @State(({ admin }: RootState) => admin.specificGroups)
  specificGroups!: Group[];

  @Action('admin/getJbicGroupChangeRequestCounts')
  getJbicGroupChangeRequestCounts!: (params?: JbicChangeRequestDTO) => void;

  @State(
    ({ admin }: RootState) => admin.apiState.getJbicGroupChangeRequestCounts
  )
  getJbicChangeRequestCountsApiState!: ApiState;

  @State(({ admin }: RootState) => admin.jbicChangeRequestCounts)
  jbicChangeRequestCounts!: JbicChangeRequest[];

  public activeTab: number = 0;
  public groupName: string = '';
  public eventPendingApprovalCount: number = 0;
  public imagePendingApprovalCount: number = 0;

  get groupId(): number {
    return +this.$route.params.groupId;
  }

  get breadcrumbs(): Breadcrumb[] {
    const root: Breadcrumb = {
      route: {
        name: 'jbic-management'
      },
      text: 'JBIC Management'
    };
    const current: Breadcrumb = {
      text: this.groupName
    };
    return [root, current];
  }

  get isJbicEventCreateRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_CREATE, this.groupId);
  }

  get isJbicEventUpdateRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_UPDATE, this.groupId);
  }

  get isJbicEventDeleteRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_DELETE, this.groupId);
  }

  get isJbicEventViewRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_READ, this.groupId);
  }

  get isJbicEventManageRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_MANAGE, this.groupId);
  }

  get isJbicImageCreateRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_CREATE, this.groupId);
  }

  get isJbicImageUpdateRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_UPDATE, this.groupId);
  }

  get isJbicImageDeleteRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_DELETE, this.groupId);
  }

  get isJbicImageViewRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_READ, this.groupId);
  }

  get isJbicImageManageRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_MANAGE, this.groupId);
  }

  get toShowEventCountBadge(): boolean {
    return this.isJbicEventManageRole && this.eventPendingApprovalCount > 0;
  }

  get toShowImageCountBadge(): boolean {
    return this.isJbicImageManageRole && this.imagePendingApprovalCount > 0;
  }

  get toShowMembersTab(): boolean {
    return this.isJbicEventViewRole || this.isJbicImageViewRole;
  }

  get toShowGroupSettings(): boolean {
    return this.isJbicEventUpdateRole || this.isJbicImageUpdateRole;
  }

  computeTagType(activeTabId: number): string {
    const selectedType: string =
      this.activeTab === activeTabId ? 'is-primary' : 'is-light';
    return selectedType;
  }

  mounted() {
    this.getSpecificGroups([this.groupId]);
    this.getJbicGroupChangeRequestCountsHandler();
  }

  getJbicGroupChangeRequestCountsHandler() {
    this.getJbicGroupChangeRequestCounts({ groupIds: [this.groupId] });
  }

  @Watch('getSpecificGroupsApiState')
  onGetSpecificGroupsApiState() {
    if (
      !this.getSpecificGroupsApiState ||
      this.getSpecificGroupsApiState.loading ||
      !this.getSpecificGroupsApiState.success ||
      !this.specificGroups
    ) {
      return;
    }

    this.groupName = this.specificGroups[0].name;
  }

  @Watch('getJbicChangeRequestCountsApiState')
  onGetJbicChangeRequestCountsApiState() {
    if (
      !this.getJbicChangeRequestCountsApiState ||
      this.getJbicChangeRequestCountsApiState.loading ||
      !this.getJbicChangeRequestCountsApiState.success ||
      !this.jbicChangeRequestCounts
    ) {
      return;
    }

    this.eventPendingApprovalCount = this.jbicChangeRequestCounts[0].eventPendingApprovalCount;
    this.imagePendingApprovalCount = this.jbicChangeRequestCounts[0].imagePendingApprovalCount;
  }
}
